import {capitalize, formatPrice, getCookie, removeToast, setCookie, toast, toastApiError, translate} from './functions';
import DataTable from 'datatables.net-bs5';
import 'datatables.net-fixedcolumns-bs5';
import {Carousel, Tab} from 'bootstrap';
import {icon} from '@fortawesome/fontawesome-svg-core';
import {faHeart as fasHeart} from '@fortawesome/free-solid-svg-icons';
import {faHeart as farHeart} from '@fortawesome/free-regular-svg-icons';

DataTable;

const newsletterTimeOut = 30E3,
    NL_MODAL_DISPLAYED = 'newsletter-modal-displayed',
    NO_SELLING_CLOSED = 'no-selling-closed',
    NLM_BUTTON_HIDDEN = 'newsletter-modal-button-hidden';

$.fn.dataTable.ext.type.detect.unshift(() => {
    return 'string';
});

$(function () {
    const defaultFadeDuration = 1E2,
        $newsletterModal = $('#singToNewsletter'),
        $noSellingModal = $('#noSelling');

    let openNlModal = setTimeout(() => {
        }),
        shouldNotOpenNlModal = !!getCookie(NL_MODAL_DISPLAYED) || !!getCookie(NLM_BUTTON_HIDDEN) || false;

    function newsletterForm() {
        const $newsletterForm = $('#newsletter-form, #singToNewsletter form');

        $newsletterForm.on('submit', e => {
            e.preventDefault();

            const $form = $(e.target),
                email = $form.serializeArray()[0].value;

            $form.find('[type="submit"]').attr('disabled', true);

            signToNewsletter(email, success => {
                if (success) {
                    $form[0].reset();
                    $newsletterModal.modal('hide', () => {
                        $newsletterModal.remove();
                    });

                    clearTimeout(openNlModal);

                    $('#singToNewsletterTrigger').fadeOut(e => {
                        $(e).remove();
                    });
                }

                $form.find('[type="submit"]').removeAttr('disabled');
            });
        });

        $newsletterModal.on('hide.bs.modal', () => {
            setCookie(NL_MODAL_DISPLAYED, true);
            clearTimeout(openNlModal);
        });
    }

    newsletterForm();

    function alertContainer() {
        $('body > .alert-container').find('.alert').each((i, e) => {
            let $alert = $(e),
                removeToastTimeOut = setTimeout(() => {
                    removeToast($alert);
                }, 2E3);

            $alert.hover(() => {
                clearTimeout(removeToastTimeOut);
            }, () => {
                removeToastTimeOut = setTimeout(() => {
                    removeToast($alert);
                }, 2E3);
            })
        });
    }

    alertContainer();

    function signToNewsletter(email, callback) {
        return $.ajax({
            url: '/api/newsletter',
            type: 'POST',
            data: JSON.stringify({email}),
            dataType: 'json',
            contentType: 'application/json',
            success: data => {
                toast(data.content.message, 'success', 8E3);

                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: error => {
                toastApiError(error);

                if (typeof callback === 'function') {
                    callback(false);
                }
            }
        }).then(function (response) {
            return response;
        })
    }

    window.addEventListener('popstate', () => {
        if (!$('body .root').hasClass('step')) {
            handleRequest({url: window.location.href, pushState: false});
        }
    });

    const $html = $('html');

    $html.on('click', 'a.js-handle', e => {
        let $link = $(e.target);

        if (!$link.is('a')) {
            $link = $link.closest('a');
        }

        const url = $link.attr('href');

        if (!url.includes('javascript')) {
            e.preventDefault();
            e.stopPropagation();

            let fadeDuration = defaultFadeDuration,
                pushState = true,
                reloadFooter = false;

            if ($link.hasClass('fade-duration-0')) {
                fadeDuration = 0;
            }

            if ($link.hasClass('push-state-0')) {
                pushState = false;
            }

            if ($link.hasClass('reload-footer')) {
                reloadFooter = true;
            }

            handleRequest({url, pushState, fadeDuration, reloadFooter});
        }
    });

    $html.on('submit', 'form.js-handle', e => {
        e.preventDefault();
        e.stopPropagation();

        const $form = $(e.target),
            url = $form.attr('action'),
            type = $form.attr('method'),
            data = $form.serialize(),
            dataType = 'json',
            $submitButton = $form.find('[type="submit"]');

        let fadeDuration = defaultFadeDuration,
            pushState = true,
            reloadFooter = false;

        if ($form.hasClass('fade-duration-0')) {
            fadeDuration = 0;
        }

        if ($form.hasClass('push-state-0')) {
            pushState = false;
        }

        if ($form.hasClass('reload-footer')) {
            reloadFooter = true;
        }

        $submitButton.attr('disabled', true);
        handleRequest({url, type, data, dataType, pushState, fadeDuration, reloadFooter}).always(() => {
            $submitButton.attr('disabled', false);
        });
    });

    function handleRequest(options) {
        const defaultOptions = {
            reloadPage: true,
            reloadNav: true,
            reloadFooter: false,
            simpleRequest: false,
            pushState: true,
            replaceState: true,
            fadeDuration: defaultFadeDuration,
            type: 'GET',
            dataType: undefined,
            data: {}
        };

        options = {...defaultOptions, ...options};

        if (!options.simpleRequest) {
            if (options.message !== undefined) {
                if (confirm(capitalize(options.message))) {
                    return request();
                }
            } else if (options.url.includes('delete') || options.url.includes('usun')) {
                translate('are you sure you want to delete this').then(message => {
                    if (confirm(capitalize(message) + '?')) {
                        return request();
                    }
                });
            } else {
                return request();
            }
        } else {
            return request();
        }

        function request() {
            return $.ajax({
                url: options.url,
                type: options.type,
                data: options.data,
                dataType: options.dataType,
                cache: false,
                success: response => {
                    if (!options.simpleRequest && response.redirect_url || response.targetUrl) {
                        if (response.redirect_url) {
                            options.url = response.redirect_url;
                        } else {
                            options.url = response.targetUrl;
                        }

                        const urlParts = options.url.split('/');

                        for (let part of urlParts) {
                            if (part.startsWith('admin')) {
                                window.location.href = options.url;
                                return;
                            }
                        }

                        options.type = 'GET';
                        handleRequest(options);
                    } else {
                        if (options.reloadPage) {
                            const $body = $('body'),
                                $content = $('<div>').html(response.content),
                                $newRoot = $content.find('.root'),
                                $newNavDesktop = $content.find('nav.navbar.nav-desktop'),
                                $newNavMobile = $content.find('nav.navbar.nav-mobile'),
                                $newFooter = $content.find('footer'),
                                $newAlertContainer = $content.find('.alert-container'),
                                $newTitle = $content.find('title');

                            $body.attr('style', '');

                            $body.find('.root').fadeOut(options.fadeDuration, () => {
                                $newRoot.attr('style', 'display: none');
                                $body.find('.root').replaceWith($newRoot);
                                $newRoot.fadeIn(options.fadeDuration, () => {
                                    if (options.fadeDuration > 0) {
                                        window.scrollTo(0, 0);
                                    }
                                });
                                $newAlertContainer.attr('style', 'display: none');
                                $body.find('.alert-container').replaceWith($newAlertContainer);
                                $('html title').replaceWith($newTitle);
                                $newAlertContainer.fadeIn(defaultFadeDuration);
                                alertContainer();

                                const $oldNavDesktop = $body.find('nav.navbar.nav-desktop');
                                if ($oldNavDesktop.length <= 0) {
                                    $newNavDesktop.insertBefore($body.find('.alert-container'));
                                } else {
                                    $oldNavDesktop.replaceWith($newNavDesktop);
                                }

                                const $oldNavMobile = $body.find('nav.navbar.nav-mobile');
                                if ($oldNavMobile.length <= 0) {
                                    $newNavMobile.insertBefore($body.find('.alert-container'));
                                } else {
                                    $oldNavMobile.replaceWith($newNavMobile);
                                }

                                const $oldFooter = $body.find('footer');

                                if (options.reloadFooter) {
                                    $oldFooter.remove();
                                    $newFooter.insertAfter($newRoot);
                                    newsletterForm();
                                } else if ($oldFooter.length > 0 && $newFooter.length <= 0) {
                                    $oldFooter.remove();
                                } else if ($oldFooter.length <= 0 && $newFooter.length > 0) {
                                    $newFooter.insertAfter($newRoot);
                                    newsletterForm();
                                }

                                reloadNav();
                                reload();
                            });


                            if (options.url === '/autoryzacja/logowanie' || options.url === '/autoryzacja/wylogowywanie') {
                                options.url = '/';
                            }

                            if (options.pushState) {
                                history.pushState({}, '', options.url);
                            } else {
                                window.history.replaceState(null, '', options.url);
                            }
                        } else if (options.reloadNav) {
                            const $body = $('body'),
                                $content = $('<div>').html(response.content),
                                $oldNavDesktop = $body.find('nav.navbar.nav-desktop'),
                                $newNavDesktop = $content.find('nav.navbar.nav-desktop'),
                                $oldNavMobile = $body.find('nav.navbar.nav-mobile'),
                                $newNavMobile = $content.find('nav.navbar.nav-mobile');

                            if ($oldNavDesktop.length > 0 && $newNavDesktop.length > 0) {
                                $oldNavDesktop.replaceWith($newNavDesktop);
                                reloadNav();
                            }

                            if ($oldNavMobile.length > 0 && $newNavMobile.length > 0) {
                                $oldNavMobile.replaceWith($newNavMobile);
                                reloadNav();
                            }
                        }
                    }
                },
                error: error => {
                    toastApiError(error);
                }
            }).always(response => {
                return response;
            }).then(response => {
                return response;
            });
        }
    }

    function reloadNav() {
        const $body = $('body'),
            $navbar = $body.find('nav.navbar');

        $navbar.find('.dropdown-hover').each((i, e) => {
            let $element = $(e);

            $element.hover(() => {
                $element.addClass('show');
                $element.parent().find('.dropdown-menu:first').addClass('show');
            }, () => {
                $element.removeClass('show');
                $element.parent().find('.dropdown-menu:first').removeClass('show');
            });

            $element.parent().find('.dropdown-menu:first').hover(() => {
                $element.addClass('show');
                $element.parent().find('.dropdown-menu:first').addClass('show');
            }, () => {
                $element.removeClass('show');
                $element.parent().find('.dropdown-menu:first').removeClass('show');
            });

            $element.on('click', e => {
                e.preventDefault();
                e.stopPropagation();

                window.location = $element.attr('href');
            });
        });

        const $searchForm = $navbar.find('form.search-form');

        $searchForm.on('submit', e => {
            e.preventDefault();

            const $input = $(e.target).find('input'),
                search = $input.val();

            if (search.trim() !== '') {
                handleRequest({url: `/szukaj/${search}`});
            } else {
                $input.closest('.input-container').addClass('expanded');
                $input.trigger('focus');
            }
        });

        $searchForm.find('input').on('blur', e => {
            const $input = $(e.target);

            if ($input.val().trim() === '') {
                $input.closest('.input-container').removeClass('expanded');
            }
        });
    }

    function reload() {
        const $body = $('body'),
            $root = $body.find('.root'),
            lang = $body.find('nav.navbar .nav-item.lang .nav-link img').data('lang'),
            $addedToCart = $body.find('#addedToCart'),
            $modalBackdrop = $html.find('.modal-backdrop');

        $root.find('a.favourite').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            let $link = $(e.target);

            if (!$link.hasClass('favourite')) {
                $link = $link.closest('.favourite')
            }

            handleRequest({
                url: $link.attr('href'),
                reloadPage: false,
                simpleRequest: true
            }).then(response => {
                if (response.redirect_url || response.targetUrl) {
                    let url;

                    if (response.redirect_url) {
                        url = response.redirect_url;
                    } else {
                        url = response.targetUrl;
                    }

                    handleRequest({
                        url, reloadPage: false, simpleRequest: true
                    }).then(response => {
                        if (response.content) {
                            const $content = $('<div>').html(response.content),
                                $alerts = $content.find('.alert');

                            if ($alerts.length) {
                                $alerts.each((i, e) => {
                                    const $alert = $(e),
                                        classList = $alert.attr('class').split(/\s+/),
                                        type = classList.find(c => c.startsWith('alert-') && c !== 'alert');

                                    toast($alert.html(), type.replace('alert-', ''));
                                });

                                return;
                            }

                            handleIcon($link);
                        }
                    });

                    return;
                }

                handleIcon($link);

                function handleIcon($link) {
                    if ($link.hasClass('last')) {
                        window.location.reload();
                    } else {
                        const $icon = $link.find('.icon');
                        let $newIcon;

                        if ($icon.hasClass('regular')) {
                            $newIcon = $(icon(fasHeart).node[0]);
                            $newIcon.addClass('icon solid');

                            translate('product was added to favourites').then(message => {
                                toast(capitalize(message), 'success');
                            });
                        } else if ($icon.hasClass('solid')) {
                            $newIcon = $(icon(farHeart).node[0]);
                            $newIcon.addClass('icon regular');

                            translate('product was removed from favourites').then(message => {
                                toast(capitalize(message), 'success');
                            });
                        }

                        $icon.replaceWith($newIcon);
                    }
                }
            });
        });

        $root.find('.product-card .card-title a, .recipe-card .card-title a, .insta-card .card-title a').hover(e => {
            const $productCard = $(e.target).parents('.product-card, .recipe-card, .insta-card');
            $productCard.find('.card-img-top').addClass('hover');
            $productCard.find('.image-container').addClass('hover');
        }, e => {
            const $productCard = $(e.target).parents('.product-card, .recipe-card, .insta-card');
            $productCard.find('.card-img-top').removeClass('hover');
            $productCard.find('.image-container').removeClass('hover');
        });

        clearTimeout(openNlModal);
        shouldNotOpenNlModal = !!getCookie(NL_MODAL_DISPLAYED) || !!getCookie(NLM_BUTTON_HIDDEN) || false;

        if (!shouldNotOpenNlModal) {
            openNlModal = setTimeout(() => {
                $newsletterModal.modal('show');
            }, newsletterTimeOut);
        }


        $noSellingModal.on('hide.bs.modal', () => {
            setCookie(NO_SELLING_CLOSED, true);
        });

        if (!getCookie(NO_SELLING_CLOSED)) {
            setTimeout(() => {
                $noSellingModal.modal('show');
            }, 3E3);
        }

        $('.copy-promo-code').on('click', e => {
            const codeText = $(e.target).text().trim();

            navigator.clipboard.writeText(codeText)
                .then(() => {
                    toast(`Skopiowano "${codeText}" do schowka`, 'success');
                })
                .catch(err => console.error('Failed to copy:', err));
        });

        $modalBackdrop.remove();

        (function cart() {
            const $dropdownToggle = $('body nav.navbar .cart .dropdown-toggle'),
                $offcanvasCart = $('#offcanvasCart');

            function disableBackdropTransition() {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach(mutation => {
                        mutation.addedNodes.forEach(node => {
                            if (node.classList && node.classList.contains('offcanvas-backdrop')) {
                                node.classList.add('no-transition');
                            }
                        });
                    });
                });

                observer.observe(document.body, {childList: true});
            }

            $body.on('click scroll touchstart touchmove', e => {
                if (!$(e.target).closest('.dropdown-menu').length) {
                    $dropdownToggle.removeClass('show');
                    $dropdownToggle.parent().find('.dropdown-menu:first').removeClass('show');
                }
            });

            function animateCartBadge() {
                var $badge = $('.nav-item.cart .badge');

                if ($badge.length) {
                    $badge.removeClass('animate');

                    void $badge[0].offsetWidth;

                    $badge.addClass('animate');
                }
            }

            if ($addedToCart.length > 0) {
                if ($('body nav.navbar.nav-mobile').is(':visible')) {
                    if ($addedToCart.hasClass('visible')) {
                        $offcanvasCart.addClass('no-transition');
                        disableBackdropTransition();
                        $offcanvasCart.offcanvas('show');
                        $offcanvasCart.on('shown.bs.offcanvas', function () {
                            $offcanvasCart.removeClass('no-transition');
                        });
                    }

                    animateCartBadge();
                } else {
                    $dropdownToggle.addClass('show');
                    $dropdownToggle.parent().find('.dropdown-menu:first').addClass('show');
                }
            }

            $body.find('nav.navbar .cart .quantity-btn-group input').on('change', e => {
                const $input = $(e.target),
                    productSizeId = $input.data('productsize');

                let quantity = parseInt($input.val());

                if (isNaN(quantity)) {
                    quantity = 1;
                }

                handleRequest({
                    url: `/koszyk/update`,
                    pushState: false,
                    fadeDuration: 0,
                    type: 'POST',
                    data: {productSizeId, quantity, openCart: true, visibleCart: $offcanvasCart.hasClass('show')},
                });
            });

            $root.on('keyup', '.promo-code input', e => {
                if (e.key === 'Enter') {
                    $(e.target).parent().find('#add-promo-code').trigger('click');
                }
            });

            $root.on('click', '#add-promo-code, #delete-promo-code', e => {
                e.preventDefault();

                const $button = $(e.target),
                    $promoCodeInput = $button.parent().find('input');

                let promoCode = $promoCodeInput.val();

                if ($button.attr('id') === 'delete-promo-code') {
                    promoCode = null;
                }

                if (promoCode === '') {
                    return;
                }

                const getOrderHash = () => {
                    const cookieOrderHash = getCookie('order-hash');

                    if (typeof cookieOrderHash !== 'undefined') {
                        return Promise.resolve(cookieOrderHash);
                    }

                    return new Promise((resolve, reject) => {
                        $.ajax({
                            url: `/koszyk/order/create`,
                            type: 'POST',
                            data: JSON.stringify({}),
                            dataType: 'json',
                            contentType: 'application/json',
                            success: response => {
                                const hash = response.redirect_url.split('/').pop();
                                resolve(hash);
                            },
                            error: error => {
                                toastApiError(error);
                                reject(error);
                            }
                        });
                    });
                };

                getOrderHash().then(cookieOrderHash => {
                    $.ajax({
                        url: `/zamowienia/promo-code/${cookieOrderHash}`,
                        type: 'PATCH',
                        data: JSON.stringify({promoCode}),
                        contentType: 'application/json',
                        success: (response) => {
                            if (window.location.pathname.includes('/krok')) {
                                if (process.env.SELF_COLLECT_CODE === promoCode) {
                                    window.location.reload();
                                }

                                $root.find('.summary').html($(response.content));
                                quantityInputs();
                            } else {
                                window.location.reload();
                            }
                        },
                        error: (error) => {
                            toastApiError(error);
                            $promoCodeInput.focus();
                        }
                    });
                });
            });

        })();

        (function carousel() {
            $body.find('.carousel .carousel-inner').hover(e => {
                const $carousel = $(e.target).closest('.carousel-inner');

                $carousel.find('.carousel-control-prev, .carousel-control-next')
                    .attr('style', 'opacity: 0')
                    .animate({opacity: 0.5}, 100);
            }, e => {
                const $carousel = $(e.target).closest('.carousel-inner');

                $carousel.find('.carousel-control-prev, .carousel-control-next').fadeOut(100);
            });
        })();

        function quantityInputs() {
            $body.find('.quantity-btn-group button.action').on('click', e => {
                let $button = $(e.target);

                if (!$button.is('button')) {
                    $button = $button.closest('button');
                }

                const $quantityInput = $button.parent().find('input'),
                    action = $button.data('action');

                let quantity = parseInt($quantityInput.val());

                if (isNaN(quantity)) {
                    quantity = 1;
                }

                if (action === 'add') {
                    quantity++;
                } else if (action === 'remove' && quantity > 1) {
                    quantity--;
                }

                $quantityInput.val(quantity).trigger('change');
            });
        }

        function isMobileDevice() {
            const userAgent = navigator.userAgent.toLowerCase();
            return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
        }

        quantityInputs();

        if ($root.hasClass('index')) {
            const $parallax = $('.parallax');

            if (isMobileDevice()) {
                $parallax.css('background-attachment', 'initial');
            }

            $(".products-category-row").each((i, e) => {
                const $scrollContainer = $(e).find(".scrollable-products");

                if ($scrollContainer.length) {
                    const $leftArrow = $(e).find(".scrollable-products-control .control.left"),
                        $rightArrow = $(e).find(".scrollable-products-control .control.right"),
                        $firstCard = $scrollContainer.find('.product-card, .product').first(),
                        cardWidth = $firstCard.outerWidth(true),
                        containerWidth = $scrollContainer.outerWidth(),
                        visibleCards = Math.floor(containerWidth / cardWidth),
                        scrollAmount = cardWidth * visibleCards;

                    function checkArrows() {
                        let scrollLeft = $scrollContainer.scrollLeft(),
                            maxScrollLeft = $scrollContainer[0].scrollWidth - containerWidth;

                        if (scrollLeft <= 0) {
                            $leftArrow.addClass("disabled");
                        } else {
                            $leftArrow.removeClass("disabled");
                        }

                        if (scrollLeft >= maxScrollLeft) {
                            $rightArrow.addClass("disabled");
                        } else {
                            $rightArrow.removeClass("disabled");
                        }
                    }

                    $leftArrow.click(function () {
                        if (!$leftArrow.hasClass("disabled")) {
                            $scrollContainer.animate({scrollLeft: "-=" + scrollAmount}, 300, checkArrows);
                        }
                    });

                    $rightArrow.click(function () {
                        if (!$rightArrow.hasClass("disabled")) {
                            $scrollContainer.animate({scrollLeft: "+=" + scrollAmount}, 300, checkArrows);
                        }
                    });

                    $scrollContainer.on("scroll", checkArrows);

                    checkArrows();
                }
            });
        }

        if ($root.hasClass('auth')) {
            const $loginTab = $root.find('#nav-login-tab'),
                $registerTab = $root.find('#nav-register-tab'),
                hash = window.location.hash;

            if (hash === '#registration') {
                const registerPane = new Tab($registerTab[0]);
                registerPane.show();
            }

            $loginTab.on('shown.bs.tab', () => {
                history.replaceState(null, null, '#login');
            });

            $registerTab.on('shown.bs.tab', () => {
                history.replaceState(null, null, '#registration');
            });
        }

        if ($root.hasClass('profile')) {
            const $settings = $root.find('.settings'),
                $userInfo = $settings.find('.info'),
                $userNameForm = $settings.find('#user-data-form');

            $userInfo.find('.edit').on('click', () => {
                $userInfo.fadeOut(defaultFadeDuration, () => {
                    $userNameForm.fadeIn(defaultFadeDuration);
                });
            });

            $userNameForm.find('.cancel').on('click', () => {
                $userNameForm.fadeOut(defaultFadeDuration, () => {
                    $userInfo.fadeIn(defaultFadeDuration);
                    $userNameForm[0].reset();
                });
            });

            $userNameForm.on('submit', e => {
                e.preventDefault();

                const url = $userNameForm.attr('action'),
                    data = {};

                $userNameForm.serializeArray().forEach(({name, value}) => {
                    data[name] = value;
                });

                $.ajax({
                    url,
                    type: 'PATCH',
                    data: JSON.stringify(data),
                    dataType: 'json',
                    contentType: 'application/merge-patch+json',
                    success: () => {
                        handleRequest({url: window.location.href, pushState: false});
                    },
                    error: error => {
                        toastApiError(error);
                    }
                });
            });
        }

        if ($root.hasClass('products')) {
            const $quantityInput = $root.find('.quantity-btn-group input'),
                $buttonAdd = $quantityInput.parent().find('[data-action="add"'),
                $buttonRemove = $quantityInput.parent().find('[data-action="remove"'),
                $notifyWhenAvailable = $root.find('#notify');

            $notifyWhenAvailable.find('button').on('click', () => {
                const email = $notifyWhenAvailable.find('input').val(),
                    productSizeId = $notifyWhenAvailable.data('productsize'),
                    url = $notifyWhenAvailable.data('href');

                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                    translate('please provide correct e-mail address').then(message => {
                        toast(capitalize(message), 'warning');
                    });

                    return;
                }

                $.ajax({
                    url,
                    type: 'POST',
                    data: JSON.stringify({email, productSizeId}),
                    dataType: 'json',
                    contentType: 'application/json',
                    beforeSend: () => {
                        $notifyWhenAvailable.find('button').attr('disabled', true);
                    },
                    success: () => {
                        translate('you will be notified when product is available again').then(message => {
                            toast(capitalize(message), 'success');
                        });

                        $notifyWhenAvailable.find('input').val('');
                    },
                    complete: () => {
                        $notifyWhenAvailable.find('button').attr('disabled', false);
                    }
                });
            });

            $quantityInput.on('change', () => {
                let quantity = parseInt($quantityInput.val());
                const max = parseInt($quantityInput.attr('max'));

                if (isNaN(quantity) || quantity <= 0) {
                    quantity = 1;
                }

                if (quantity === 1) {
                    $buttonRemove.addClass('disabled');
                } else {
                    $buttonRemove.removeClass('disabled');
                }

                if (quantity > max) {
                    quantity = max;
                }

                if (quantity === max) {
                    $buttonAdd.addClass('disabled');
                } else {
                    $buttonAdd.removeClass('disabled');
                }

                $quantityInput.val(quantity);

                const $addToCart = $root.find('.add-to-cart'),
                    $buyNow = $root.find('.buy-now');

                $addToCart.attr('href', $addToCart.attr('href').replace(/(\/koszyk\/dodaj\/produkt\/\d+)(\/\d+)?$/, '$1/' + quantity));
                $buyNow.attr('href', $buyNow.attr('href').replace(/(\/koszyk\/kup\/produkt\/\d+)(\/\d+)?$/, '$1/' + quantity));
            });

            new Carousel($root.find('#productPicturesCarousel')[0]);
        }

        if ($root.hasClass('sets')) {
            const data = {
                'productSizes': [],
                'miniProducts': [],
            };

            $root.on('click', '.product-lines .set-product-size:not(.disabled)', e => {
                let $setProductSize = $(e.target);

                if (!$setProductSize.hasClass('set-product-size')) {
                    $setProductSize = $setProductSize.closest('.set-product-size');
                }

                $setProductSize.closest('.product-line').find('.selected').removeClass('selected');
                $setProductSize.addClass('selected');

                updateProductSizes();
            });

            $root.find('.mini-products .mini-product .set-quantity-btn-group button.action').on('click', e => {
                let $button = $(e.target);

                if (!$button.is('button')) {
                    $button = $button.closest('button');
                }

                const $quantityInput = $button.parent().find('input'),
                    action = $button.data('action');

                let quantity = parseInt($quantityInput.val());

                if (isNaN(quantity)) {
                    quantity = 0;
                }

                if (action === 'add') {
                    quantity++;
                } else if (action === 'remove' && quantity >= 1) {
                    quantity--;
                }

                $quantityInput.val(quantity).trigger('change');
            });

            $root.find('.mini-products .mini-product input').on('change', e => {
                const $input = $(e.target),
                    $miniProduct = $input.closest('.mini-product'),
                    max = $miniProduct.data('quantity');

                let quantity = $input.val();

                if (quantity > max) {
                    quantity = max;
                } else if (quantity < 0) {
                    quantity = 0;
                }

                if (quantity > 0) {
                    $miniProduct.find('.action[data-action=remove]').removeClass('disabled');
                } else {
                    $miniProduct.find('.action[data-action=remove]').addClass('disabled');
                }

                if (quantity >= max) {
                    $miniProduct.find('.action[data-action=add]').addClass('disabled');
                } else {
                    $miniProduct.find('.action[data-action=add]').removeClass('disabled');
                }

                $input.val(quantity);

                updateMiniProducts();
            });

            function updateProductSizes() {
                data.productSizes = [];

                $root.find('.product-lines .set-product-size.selected').each((i, e) => {
                    const $setProductSize = $(e),
                        productId = $setProductSize.data('id'),
                        existingProductSize = data.productSizes.find(ps => ps.id === productId);

                    $setProductSize.closest('.product-line').prev().find('.tick').html('✓');

                    if (existingProductSize) {
                        existingProductSize.quantity += 1;
                    } else {
                        data.productSizes.push({
                            id: productId,
                            quantity: 1
                        });
                    }
                });

                updatePrice()
            }

            function updateMiniProducts() {
                let count = 0;
                data.miniProducts = [];

                $root.find('.mini-products .mini-product').each((i, e) => {
                    const $miniProduct = $(e),
                        id = $miniProduct.data('id'),
                        quantity = parseInt($miniProduct.find('input').val());

                    count += quantity;

                    data.miniProducts.push({id, quantity});
                });

                const allowance = parseInt($root.find('.mini-products').data('allowance'));

                $root.find('.mini-products .title .amount').html('(' + (allowance - count) + ')');

                if (allowance - count <= 0) {
                    $root.find('.mini-products .title .amount').html('✓');
                }

                if (count >= allowance) {
                    $root.find('.mini-products .mini-product .set-quantity-btn-group [data-action=add]').attr('disabled', true);
                    $root.find('.mini-products .title').addClass('success');
                } else {
                    $root.find('.mini-products .mini-product .set-quantity-btn-group [data-action=add]').removeAttr('disabled');
                    $root.find('.mini-products .title').removeClass('success');
                }

                updatePrice()
            }

            function updatePrice() {
                const $set = $root.find('.set');

                $.ajax({
                    url: '/api/sets/price',
                    type: 'POST',
                    data: JSON.stringify({...data, set: $set.data('set')}),
                    contentType: 'application/json',
                    success: (response) => {
                        if (response.success) {
                            $set.find('.prices .price-discount .price').html(formatPrice(response.discount));
                            $set.find('.prices .price-no-discount .price').html(formatPrice(response.noDiscount));
                        }
                    },
                    error: (error) => {
                        toastApiError(error);
                    }
                });
            }

            $root.on('click', 'a.add-to-cart', e => {
                e.preventDefault();
                e.stopPropagation();

                const $a = $(e.target);

                $.ajax({
                    url: $a.attr('href'),
                    type: 'POST',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: (response) => {
                        if (response.error) {
                            toast(response.error, 'danger');
                        }

                        if (response.redirect_url) {
                            handleRequest({url: response.redirect_url, fadeDuration: 0, pushState: false});
                        }
                    },
                    error: (error) => {
                        toastApiError(error);
                    }
                });
            });

            $root.on('click', 'a.buy-now', e => {
                e.preventDefault();
                e.stopPropagation();

                const $a = $(e.target);

                $.ajax({
                    url: $a.attr('href'),
                    type: 'POST',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: (response) => {
                        if (response.error) {
                            toast(response.error, 'danger');
                        }

                        if (response.redirect_url) {
                            window.location.href = response.redirect_url;
                        }
                    },
                    error: (error) => {
                        toastApiError(error);
                    }
                });
            });

            new Carousel($root.find('#setPicturesCarousel')[0]);
        }

        if ($root.hasClass('orders')) {
            let $ordersTable = $root.find('table.orders'),
                dataTablePageLength = getCookie('datatable_user_len');

            if (dataTablePageLength === undefined) {
                dataTablePageLength = 25;
            }

            let dtOptions = {
                pageLength: dataTablePageLength,
                scrollCollapse: true,
                scrollX: true,
                columnDefs: [
                    {targets: [0, 1], orderable: true},
                    {targets: 4, type: 'currency-zloty', className: 'text-end', orderable: true},
                    {targets: '_all', orderable: false}
                ],
                order: [[0, 'desc']]
            };

            if (lang !== 'en') {
                dtOptions.language = {
                    url: `/datatables.${lang}.json`
                };
            }

            $ordersTable.DataTable(dtOptions);

            $ordersTable.on('length.dt', (e, s, len) => {
                setCookie('datatable_user_len', len, 4384);
            });
        }

        if ($root.hasClass('cart')) {
            $root.find('.cart-product-card .quantity-btn-group input').on('change', e => {
                let $input = $(e.target),
                    quantity = parseInt($input.val()),
                    productSizeId = $input.data('productsize');

                if (isNaN(quantity)) {
                    quantity = 0;
                }

                handleRequest({
                    url: `/koszyk/update`,
                    pushState: false,
                    fadeDuration: 0,
                    type: 'POST',
                    data: {productSizeId, quantity}
                });
            });
        }

        if ($root.hasClass('step')) {
            $root.find('.progress-steps .numbers a').on('click', e => {
                let $a = $(e.target);

                if (!$a.hasClass('step-link')) {
                    $a = $a.closest('.step-link');
                }

                if ($a.attr('href') === '#') {
                    e.preventDefault();
                }
            });

            const $deliveryAddress = $root.find('.delivery'),
                $deliveryAddressCheckbox = $root.find('#delivery-address-checkbox'),
                $newAccountPassword = $root.find('.new-account-password'),
                $newAccountCheckbox = $root.find('#new-account-checkbox'),
                $newAddress = $root.find('.new-address'),
                $newAddressCheckbox = $root.find('#new-address-checkbox'),
                $step3payButton = $root.find('.step3-pay'),
                $orlenPaczkaMapModal = $html.find('#orlenPaczkaMapModal'),
                $noLoginButton = $root.find('#noLogin');

            $root.find('[id^=delivery-address]').on('change', e => {
                if ($(e.target).attr('id') !== 'delivery-address-checkbox') {
                    $deliveryAddressCheckbox.trigger('change');
                }
            });

            $deliveryAddressCheckbox.on('change', e => {
                if ($(e.target).prop('checked')) {
                    $deliveryAddress.fadeIn();
                } else {
                    $deliveryAddress.fadeOut();
                }
            });

            $newAccountCheckbox.on('change', e => {
                if ($(e.target).prop('checked')) {
                    $newAccountPassword.fadeIn();
                } else {
                    $newAccountPassword.fadeOut();
                }
            });

            $newAddressCheckbox.on('change', e => {
                if ($(e.target).prop('checked')) {
                    $newAddress.fadeIn();
                    $root.find('.address-card.selected').removeClass('selected');
                } else {
                    $newAddress.fadeOut();
                }
            });

            $root.find('.address-card button.select').on('click', e => {
                $root.find('.address-card.selected').removeClass('selected');
                $(e.target).closest('.address-card').addClass('selected');
                $newAddressCheckbox.prop('checked', false).trigger('change');
            });

            function shippingCard() {
                $root.find('.shipping-card').on('click', e => {
                    let $previousCard = $root.find('.shipping-card.selected'),
                        $card = $(e.target),
                        $parent = $card.closest('#step-2, #step-3');

                    if ($parent.attr('id') === 'step-3') {
                        return;
                    }

                    $root.find('.shipping-card.error').removeClass('error');

                    const orderHash = $parent.data('order');

                    if (!$card.hasClass('.shipping-card')) {
                        $card = $card.closest('.shipping-card');
                    }

                    if ($card.data('value') === 2) {
                        $orlenPaczkaMapModal.modal('show');
                    }

                    $.ajax({
                        url: `/koszyk/order/update/${orderHash}`,
                        type: 'POST',
                        data: JSON.stringify({shippingMethod: $card.data('value')}),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: () => {
                            $previousCard.removeClass('selected');
                            $card.addClass('selected');

                            let price = parseFloat($card.find('.price').text()),
                                sumPrice = parseFloat($root.find('.summary .sum .price').text()) - parseFloat($previousCard.find('.price').text()) + price;

                            $root.find('.summary .shipping-cost .price').html(price.toFixed(2).replace('.', ','));
                            $root.find('.summary .sum .price').html(sumPrice.toFixed(2).replace('.', ','));
                        },
                        error: error => {
                            toastApiError(error);
                        }
                    });
                });
            }

            shippingCard();

            // $root.find('.payment-card').on('click', e => {
            //     let $card = $(e.target);
            //
            //     if (!$card.hasClass('payment-card')) {
            //         $card = $card.closest('.payment-card');
            //     }
            //
            //     $root.find('.payment-card.selected').removeClass('selected')
            //     $card.addClass('selected');
            // });

            $root.on('change', '.summary .quantity-btn-group input', e => {
                let $quantityInput = $(e.target),
                    quantity = parseInt($quantityInput.val()),
                    $step = $quantityInput.closest('#step-2, #step-3'),
                    orderHash = $step.data('order'),
                    itemId = $quantityInput.data('item') || $quantityInput.data('productsize');

                if (isNaN(quantity)) {
                    quantity = 1;
                }

                $root.find(`.summary .quantity-btn-group input[data-item='${itemId}']`).val(quantity);

                $.ajax({
                    url: `/zamowienia/update/${orderHash}`,
                    type: 'PATCH',
                    data: JSON.stringify({itemId, quantity, step: parseInt($step.attr('id').replace('step-', ''))}),
                    contentType: 'application/json',
                    success: (response) => {
                        $root.find('.summary').html($(response.content));
                        quantityInputs();

                        $.ajax({
                            url: `/koszyk/krok/shipping-cards/${orderHash}`,
                            type: 'GET',
                            contentType: 'application/json',
                            success: (response) => {
                                $root.find('.shipping-cards').replaceWith($(response.content));
                                shippingCard();
                            },
                            error: (error) => {
                                toastApiError(error);
                            }
                        });
                    },
                    error: (error) => {
                        toastApiError(error);
                    }
                });
            });

            $root.find('#regulations').on('change', e => {
                const $checkbox = $(e.target);

                if ($checkbox.prop('checked')) {
                    $root.find("form.no-login").removeClass('was-validated');
                }
            });

            $noLoginButton.on('click', e => {
                e.preventDefault();
                if ($root.find('#regulations').prop('checked')) {
                    window.location.href = '/koszyk/krok/2';
                } else {
                    $root.find("form.no-login").addClass('was-validated');
                }
            });

            const $step2 = $root.find('#step-2');

            function cartPopstate() {
                if (window.location.href.includes('krok/2') || window.location.href.includes('krok/3')) {
                    if (window.location.href.includes('krok/3')) {
                        let $step3 = $('.steps #step-3');
                        if ($step3.length) {
                            let $step2 = $('.steps #step-2');
                            $step2.fadeOut(defaultFadeDuration, () => {
                                $step3.fadeIn(defaultFadeDuration);
                            });
                        } else {
                            handleRequest({url: window.location.href, pushState: false});
                        }
                    } else {
                        let $step2 = $('.steps #step-2');
                        if ($step2.length) {
                            let $step3 = $('.steps #step-3');
                            $step3.fadeOut(defaultFadeDuration, () => {
                                $step2.fadeIn(defaultFadeDuration);
                            });
                        } else {
                            handleRequest({url: window.location.href, pushState: false});
                        }
                    }
                } else {
                    handleRequest({url: window.location.href, pushState: false});
                }
            }

            window.removeEventListener('popstate', cartPopstate);

            if (!window.popstateAttached) {
                window.addEventListener('popstate', cartPopstate);
                window.popstateAttached = true;
            }

            if ($step2.length) {
                const orderHash = $step2.data('order'),
                    wid = new RuchWidget('map',
                        {
                            selectCb: p => {
                                if (null !== p) {
                                    $.ajax({
                                        url: `/koszyk/order/update/${orderHash}`,
                                        type: 'POST',
                                        data: JSON.stringify({orlenPaczka: {id: p.id, address: p.a}}),
                                        dataType: 'json',
                                        contentType: 'application/json',
                                        success: () => {
                                            $orlenPaczkaMapModal.modal('hide');
                                            $root.find('.shipping-card[data-value=2] .card-text .description').html(p.a);
                                        },
                                        error: error => {
                                            toastApiError(error);
                                        }
                                    });
                                }
                            },
                            initialAddress: 'Kraków',
                            sandbox: false
                        }
                    );

                $root.find("#map").replaceWith($('<div id="map"></div>'));

                wid.init();

                $orlenPaczkaMapModal.on('shown.bs.modal', () => {
                    wid.showWidget(
                        0,
                        {
                            'R': 11,
                            'P': 11,
                            'U': 11,
                            'A': 11
                        },
                        {
                            'R': 'ruch',
                            'P': 'partner',
                            'U': 'partner',
                            'A': 'orlen'
                        }
                    );
                });

                if (typeof orderHash == 'undefined') {
                    const cookieOrderHash = getCookie('order-hash');

                    if (typeof cookieOrderHash == 'undefined') {
                        $.ajax({
                            url: `/koszyk/order/create`,
                            type: 'POST',
                            data: JSON.stringify({}),
                            dataType: 'json',
                            contentType: 'application/json',
                            success: response => {
                                handleRequest({url: response.redirect_url, fadeDuration: 0, pushState: false});
                            },
                            error: error => {
                                toastApiError(error);
                            }
                        });
                    } else {
                        handleRequest({url: `/koszyk/krok/2/${cookieOrderHash}`, fadeDuration: 0, pushState: false});
                    }
                }

                let $step2nextButton = $root.find('.step-next');

                $step2nextButton.on('click', e => {
                    e.preventDefault();

                    let billingAddressData, $selectedAddress = $root.find('.address-card.selected'),
                        $billingAddressForm = $root.find('.billing form'),
                        $deliveryAddressForm = $root.find('.delivery form');

                    const validateForm = ($form) => {
                        let requiredFields = ['firstName', 'lastName', 'phone', 'email', 'country', 'postcode', 'city', 'house'],
                            missingFields = [];

                        const formData = $form.serializeArray().reduce((acc, curr) => {
                            acc[curr.name] = curr.value;
                            return acc;
                        }, {});

                        requiredFields.forEach(field => {
                            if (!formData[field] || formData[field].trim() === '') {
                                missingFields.push(field);
                            }
                        });

                        $form.addClass('was-validated');
                        return {formData, missingFields};
                    };

                    $billingAddressForm.find('input').on('keydown', () => {
                        $billingAddressForm.removeClass('was-validated');
                    });

                    $billingAddressForm.find('input').on('click', () => {
                        $billingAddressForm.removeClass('was-validated');
                    });

                    $deliveryAddressForm.find('input').on('keydown', () => {
                        $deliveryAddressForm.removeClass('was-validated');
                    });

                    $deliveryAddressForm.find('input').on('click', () => {
                        $deliveryAddressForm.removeClass('was-validated');
                    });

                    if ($selectedAddress.length <= 0) {
                        const billingData = validateForm($billingAddressForm);
                        billingAddressData = billingData.formData;

                        if (billingData.missingFields.length > 0) {
                            return;
                        }
                    } else {
                        billingAddressData = $selectedAddress.data('id');
                    }

                    let deliveryAddressData = billingAddressData;

                    if ($deliveryAddressCheckbox.prop('checked')) {
                        const deliveryData = validateForm($deliveryAddressForm);
                        deliveryAddressData = deliveryData.formData;

                        if (deliveryData.missingFields.length > 0) {
                            return;
                        }
                    }

                    let data = {billingAddressData, deliveryAddressData};

                    if (billingAddressData === deliveryAddressData) {
                        data = {billingAddressData, deliveryAddressData: null};
                    }

                    data['shippingMethod'] = $root.find('.shipping-card.selected').data('value');
                    data['comment'] = $root.find('#order-comment').val();

                    if ($newAccountCheckbox.prop('checked')) {
                        const $passwordInput = $newAccountPassword.find('#registerPassword'),
                            $rpasswordInput = $newAccountPassword.find('#confirmPassword'),
                            password = $passwordInput.val(),
                            rpassword = $rpasswordInput.val();

                        if (password === '' || rpassword === '' || password !== rpassword) {
                            if (password !== rpassword) {
                                $billingAddressForm.removeClass('was-validated');
                                $deliveryAddressForm.removeClass('was-validated');

                                translate('passwords do not match').then(message => {
                                    $passwordInput.addClass('is-invalid').parent().find('.invalid-feedback').html(capitalize(message));
                                    $rpasswordInput.addClass('is-invalid').parent().find('.invalid-feedback').html(capitalize(message));
                                });
                            }

                            $('html, body').animate({
                                scrollTop: $passwordInput.offset().top - 100
                            }, 500);

                            return;
                        }

                        data['password'] = password;
                        data['rpassword'] = rpassword;
                    }

                    nextStep(`/koszyk/order/update/${orderHash}`, data, 'POST');

                    function nextStep(url, data = {}, type = 'GET') {
                        const ajaxOptions = {
                            url,
                            type,
                            dataType: 'json',
                            contentType: 'application/json',
                            beforeSend: () => {
                                $step2nextButton.attr('disabled', true);
                            },
                            success: response => {
                                if (response.redirect_url) {
                                    nextStep(response.redirect_url);
                                } else if (response.content && response.content.redirect_url) {
                                    window.location.href = response.content.redirect_url;
                                } else {
                                    let $stepsContainer = $root.find('.steps'),
                                        $step2 = $stepsContainer.find('#step-2'),
                                        $step3 = $stepsContainer.find('#step-3'),
                                        $newStep2 = $step2.clone(false);

                                    if ($step3.length) {
                                        $step3.remove();
                                    }

                                    $step3 = $(response.content).find('#step-3');
                                    $step3.attr('style', 'display: none;');
                                    $step3.appendTo($stepsContainer);

                                    let newUrl = `/koszyk/krok/3/${orderHash}`;
                                    history.pushState({step: 3}, '', newUrl);

                                    $step2.remove();
                                    $newStep2.appendTo($stepsContainer);

                                    $newStep2.fadeOut(defaultFadeDuration, () => {
                                        $newStep2.find('.step-next').attr('disabled', false);
                                        $step3.fadeIn(defaultFadeDuration);

                                        reload();
                                    });
                                }
                            },
                            error: error => {
                                const errorDetails = JSON.parse(error.responseText),
                                    code = errorDetails.status || errorDetails.code || 500;

                                if (code === 498) {
                                    $root.find('.shipping-card.selected').addClass('error');
                                } else {
                                    toastApiError(error);
                                }
                            },
                            complete: () => {
                                $step2nextButton.attr('disabled', false);
                            }
                        };

                        if (type !== 'GET') {
                            ajaxOptions.data = JSON.stringify(data);
                        }

                        $.ajax(ajaxOptions);
                    }
                });
            }

            const $step3 = $root.find('#step-3');

            if ($step3.length) {
                $step3.find('a.step-prev').on('click', e => {
                    e.preventDefault();

                    let newUrl = window.location.href.replace('/krok/3', '/krok/2');
                    history.pushState({step: 2}, '', newUrl);
                    cartPopstate();
                });

                $step3payButton.on('click', () => {
                    const orderHash = $root.find('#step-3').data('order');

                    $.ajax({
                        url: `/koszyk/order/pay/${orderHash}`,
                        type: 'POST',
                        dataType: 'json',
                        contentType: 'application/json',
                        beforeSend: () => {
                            $step3payButton.attr('disabled', true);
                        },
                        success: response => {
                            if (response.error) {
                                toast(response.error, 'danger');
                            }
                            if (response.redirect_url) {
                                window.location.href = response.redirect_url;
                            }
                        },
                        error: error => {
                            toastApiError(error);
                        },
                        complete: () => {
                            $step3payButton.attr('disabled', false);
                        }
                    });
                });
            }
        }
    }

    reloadNav();
    reload();
});
